import React, { Component } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import YogaNav from './components/layout/YogaNav'
import AllPosesAdmin from './components/admin/AllPosesAdmin'
import AdminDashboard from './components/admin/AdminDashboard';
import SignIn from './components/auth/SignIn'
import SignUp from './components/auth/SignUp'
import About from './components/yogaPoses/About'
import EditPose from './components/admin/EditPose'
import Dashboard from './components/yogaPoses/Dashboard';
import UserProfile from './components/user/UserProfile'

class App extends Component {
  render() {
    return (
      <HashRouter>
        <React.Fragment>
          <header>
            <YogaNav />
          </header>
          <main>
            <div className="container">
              <Switch>
                <Route path='/signin' component={SignIn} />
                <Route path='/signup' component={SignUp} />
                <Route path='/about' component={About} />
                <Route path='/admin/poses/:id/edit' component={EditPose} />
                <Route path='/admin/poses' component={AllPosesAdmin} />
                <Route path='/admin/create' component={AdminDashboard} />
                <Route path='/user/profile' component={UserProfile} />
                <Route exact path='/' component={Dashboard} />
              </Switch>
            </div>
          </main>
        </React.Fragment>
      </HashRouter>
    );
  }
}

export default App;

// Button to display all poses
// Button to filter and / or roll the dice. 
